// What a scale cell is called on screen: the tonic it is written from, then the scale's name.
//
// The screen follows the notation: where a cell is written from the enharmonic tonic (the Bb
// Superlocrian cell is written as A# Superlocrian), the key chooser and the title show that
// written spelling. The cell's stored identity (its scale and tonic label) never changes.

import type { ScaleCell } from 'Types/ExerciseContentTypes';
import { unitIdForScaleSlug } from './scaleLevels';
import { SCALE_UNITS } from './scaleLibraryCatalog';
import { writtenTonic } from './scaleNotation';
import type { TonicName } from './scaleSpelling';

/** The tonic a cell is shown and written with. */
export const shownTonic = (cell: ScaleCell): TonicName =>
  writtenTonic(unitIdForScaleSlug(cell.scale), cell.tonic);

/** "A# Superlocrian": the shown tonic and the scale's first catalog name. */
export const writtenCellName = (cell: ScaleCell): string => {
  const unitId = unitIdForScaleSlug(cell.scale);
  const name = SCALE_UNITS[unitId]?.name.split(' / ')[0] ?? cell.scale;
  return `${shownTonic(cell)} ${name}`;
};
